import React from 'react';
import { DropletsIcon, SparklesIcon, ClockIcon, CheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import type { ServiceIcon } from '../data/content';
const icons: Record<ServiceIcon, React.ComponentType<{
  className?: string;
}>> = {
  wash: DropletsIcon,
  vacuum: DropletsIcon,
  sparkle: SparklesIcon,
  truck: SparklesIcon
};
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="bg-white py-20 sm:py-24" data-id="element-283" data-mp="z4mn50ktfcrw">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-284" data-mp="z31szc2exvuk">
        <SectionHeading kicker={t.services.kicker} title={t.services.title} subtitle={t.services.subtitle} data-id="element-285" data-mp="u6uwsaztjypt" />

        <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-286" data-mp="l5djf0dsqb4t">
          {t.services.items.map(service => {
          const Icon = icons[service.icon];
          const premium = service.featured;
          return <article key={service.name} className={`flex flex-col rounded-xl border p-7 shadow-card transition-shadow duration-200 hover:shadow-lift sm:p-9 ${premium ? 'border-brand-orange bg-navy' : 'border-navy/10 bg-mist'}`} data-id="element-287" data-mp="36besjyf97dip">
                <div className="flex items-start justify-between gap-4" data-id="element-288" data-mp="32be3ljuj3jxe">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${premium ? 'bg-brand-orange/15 text-brand-orange' : 'bg-white text-brand-blue'}`} data-id="element-289" data-mp="3q074luq0chyv">
                    <Icon className="h-6 w-6" data-id="element-290" data-mp="3g4n7x63mdf92" />
                  </span>
                  {premium && <span className="rounded-full bg-brand-orange px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-291" data-mp="24n3z8y79sk34">
                      {t.services.mostBooked}
                    </span>}
                </div>

                <h3 className={`mt-6 font-display text-2xl font-bold leading-snug sm:text-[26px] ${premium ? 'text-white' : 'text-navy'}`} data-id="element-292" data-mp="1pisv891egrhy">
                  {service.name}
                </h3>
                <p className={`mt-3 max-w-xl text-base leading-relaxed ${premium ? 'text-white/70' : 'text-ink/70'}`} data-id="element-293" data-mp="1bt7ivhi3vaiw">
                  {service.description}
                </p>

                <ul className="mt-7 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2" data-id="element-294" data-mp="11t6zjvk8kuep">
                  {service.features.map(feature => <li key={feature} className={`flex items-start gap-2.5 text-sm ${premium ? 'text-white/85' : 'text-ink/80'}`} data-id="element-295" data-mp="suli63qi3lfi">
                      <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-brand-orange' : 'text-brand-blue'}`} aria-hidden="true" data-id="element-296" data-mp="2n8mi6rxseeh6" />
                      {feature}
                    </li>)}
                </ul>

                <div className="mt-auto pt-8" data-id="element-297" data-mp="39f8f2ffnusz9">
                  <p className={`flex items-center gap-2 text-sm font-medium ${premium ? 'text-white/70' : 'text-ink/60'}`} data-id="element-298" data-mp="39i2z45uribs5">
                    <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-299" data-mp="2lqp4tud1w64j" />
                    {service.duration}
                  </p>
                  <a href="#contact" className={`mt-4 flex min-h-[48px] items-center justify-center rounded-lg px-6 text-base font-semibold transition-colors duration-150 ${premium ? 'bg-brand-orange text-white hover:bg-brand-orangeDark' : 'bg-navy text-white hover:bg-navy-700'}`} data-id="element-300" data-mp="2psj17qg7qnyw">
                    {service.cta}
                  </a>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}